
import { CookieComponent } from "@/assets/ts/components/_CookieComponent";
/* import { Provinces, Districts } from "@/store/enums/StoreEnums"; */
import { useStore } from "vuex";
import { defineComponent, ref } from "vue";
import { Roles } from "@/store/enums/StoreEnums";

interface Filter {
  cTenTaiKhoan: string| number| null,
  cHoTen: string| number| null,
  cSoDienThoai: string| number| null,
  searchrole: number| null,
  searchStatus: number| null,
}

export default defineComponent({
  name: "account-filter",
  components: {},

  emits: ["search"],
  setup(props) {
    const store = ref(useStore());
    const data = ref<Filter>({
      cTenTaiKhoan: "",
      cHoTen: "",
      cSoDienThoai: "",
      searchrole: -1,
      searchStatus: -1,
    });
    const defaultVal = ref<Filter>({
      cTenTaiKhoan: "",
      cHoTen: "",
      cSoDienThoai: "",
      searchrole: -1,
      searchStatus: -1,
    });
    const RoleList = ref<Array<Object>>([])
    return {
      defaultVal,
      data,
      store,
      RoleList
    };
  },
  methods: {
    handleFindPage() {
      this.$emit("search", this.data);
    },
    handleReset() {
      if (this.defaultVal != this.data) {
        this.data = Object.assign({}, this.defaultVal);
        this.$emit("search", this.data);
      }
    },
    /* handleFindDistrictByProvince() {
      this.store.dispatch(
        Districts.findDistrictByProvinceCodeVer2,
        this.data.provinceCode
      ).then(res => {
        this.Districts = res.data
      })
    }, */
    findAllRoles() {
      this.store
        .dispatch(Roles.findAllRole)
        .then((res) => {
          if (res.code == 200) {
            this.RoleList = res.data;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  mounted() {
    /* if (this.roleID != "1") {
      this.data.nMaCongTy = CookieComponent.get("companyID") as string;
      this.defaultVal.nMaCongTy = CookieComponent.get("companyID") as string;
    } */
    this.handleReset();
    this.findAllRoles()
  },
});
